export const PROJECT_BITRIX = 'bitrix'
export const PROJECT_SAMOLET = 'samolet'

export type ProjectMode = typeof PROJECT_BITRIX | typeof PROJECT_SAMOLET

/**
 * Нормализует query-параметр `project` в поддерживаемый режим.
 *
 * Мы принимаем только известные значения, чтобы не включать Bitrix-ветки
 * для произвольных проектных тегов из URL.
 *
 * @param queryProject исходное значение `project` из query
 */
export function resolveProjectMode(
  queryProject: string | string[] | undefined | null,
): ProjectMode | null {
  const value = typeof queryProject === 'string' ? queryProject.trim() : null

  if (value === PROJECT_BITRIX || value === PROJECT_SAMOLET) {
    return value
  }

  return null
}

/**
 * Проверяет, что текущий режим относится к Bitrix.
 *
 * @param mode нормализованный режим проекта
 */
export function isBitrixProjectMode(mode: ProjectMode | null): boolean {
  return mode === PROJECT_BITRIX
}

/**
 * Проверяет, что текущий режим относится к Самолёту.
 *
 * @param mode нормализованный режим проекта
 */
export function isSamoletProjectMode(mode: ProjectMode | null): boolean {
  return mode === PROJECT_SAMOLET
}

/**
 * Определяет, нужно ли пропускать Platform `check_meet`.
 *
 * @param mode нормализованный режим проекта
 */
export function shouldSkipCheckMeet(mode: ProjectMode | null): boolean {
  return mode === PROJECT_BITRIX || mode === PROJECT_SAMOLET
}

/**
 * Управляет показом телефонного поля на prejoin.
 *
 * @param mode нормализованный режим проекта
 */
export function shouldShowPhoneField(mode: ProjectMode | null): boolean {
  return mode === PROJECT_SAMOLET
}

/**
 * Управляет запуском prejoin_check до входа в комнату.
 *
 * @param mode нормализованный режим проекта
 */
export function shouldRunPrejoinCheck(mode: ProjectMode | null): boolean {
  return mode !== PROJECT_BITRIX
}

/**
 * Управляет показом инструкций Самолёта на prejoin.
 *
 * @param mode нормализованный режим проекта
 * @param v значение параметра режима комнаты
 */
export function shouldShowSamoletInstructions(mode: ProjectMode | null, v: string | null): boolean {
  return mode === PROJECT_SAMOLET && v !== 'hr'
}

/**
 * Управляет показом текста пользовательского соглашения Самолёта.
 *
 * @param mode нормализованный режим проекта
 */
export function shouldShowSamoletTerms(mode: ProjectMode | null): boolean {
  return mode === PROJECT_SAMOLET
}
